import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subscription, of, BehaviorSubject } from 'rxjs';
import { Store } from '@ngrx/store';
import { IndexedDbService, getActiveManifestItem, ModalService, ManifestController, BigFormService } from '@flexus/core';
import { take } from 'rxjs/operators';
import { SpFlowComponent } from '../../sp_globals/base-components/sp-flow/sp-flow.component';
import { SpWorkflowShellComponent } from '../../sp_globals/base-components/sp-workflow-shell/sp-workflow-shell.component';

@Injectable({ providedIn: 'root' })
export class DeactivateStateGuard implements OnDestroy, CanDeactivate<SpFlowComponent | SpWorkflowShellComponent> {
	canGo$ = new BehaviorSubject(false);
	canDiscard: boolean;
	manifestItem;
	manifestItemSub: Subscription;
	constructor(
		public indexedDbService: IndexedDbService,
		private controller: ManifestController<any>,
		public store: Store<any>,
		public modalService: ModalService,
		public bf: BigFormService,
		public router: Router
	) {
		this.manifestItemSub = this.controller
			.select(getActiveManifestItem)
			.pipe(take(1))
			.subscribe(item => (this.manifestItem = item));
	}

	canDeactivate(
		component: SpFlowComponent,
		currentRoute: ActivatedRouteSnapshot,
		currentState: RouterStateSnapshot,
		nextState: RouterStateSnapshot
	): Observable<boolean> | boolean | Promise<boolean> {
		if (this.manifestItem?.deactivateStateGuard) {
			return this.manifestItem.deactivateStateGuard(this, component, this.router, currentRoute, currentState, nextState);
			//  return this.canGo.asObservable();
		} else {
			return of(true);
		}
	}

	resetCanGoVariable() {
		this.canGo$.next(false);
	}

	ngOnDestroy() {
		if (this.manifestItemSub) this.manifestItemSub.unsubscribe();
	}
}
